import React from 'react';

import '../../styles/PnrSeoPage.css';
import PropTypes from 'prop-types';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';
import { FOOTER_DATA_IRCTC } from '../../utils/RailsSEOConstants';
import PnrStatusCard from './components/PnrStatusCard';
import TicketStatusTiles from './components/TicketStatusTiles';
import HtmlHeader from '../components/HtmlHeader';
import WhyMMTRail from './components/WhyMMTRail';
import { PNR_FAQ, PNR_META_DATA, PNR_PAGE_CONTENT } from './constants/PnrSeoConstants';
import PnrFooter from './components/PnrFooter';
import { BreadCrumb, FaqSection } from '../components';
import GPTComponent from '../components/GPT/GPTComponent';
import TripGuarantee from '../components/TG/TripGuaranteeComponent';
import PnrAppDownloadSection from './components/PnrAppDownloadSection';

const PnrSeo = (props) => {
  const { data } = props;
  const {
    template: { h1_title: IRCTC_PNR_STATUS_TITLE }
  } = data;

  return (
    <React.Fragment>
      <HtmlHeader data={data} />
      <div className="banner">
        <div className="contentWpr">
          <div className="railsPNRBreadcrumb">
            <BreadCrumb breadcrumb={data.template.breadcrumb} />
          </div>
          <PnrStatusCard customClass="appendBottom60" title={IRCTC_PNR_STATUS_TITLE} />
          <TripGuarantee />
          <GPTComponent />
          <TicketStatusTiles />
        </div>
      </div>
      <main>
        <div className="contentWpr">
          <WhyMMTRail customClass="appendBottom60" />
          <div className="contentPadding">
            {PNR_PAGE_CONTENT.map((pageContent) => (
              <div
                className="contentItem"
                key={pageContent.key}
                dangerouslySetInnerHTML={{ __html: pageContent.description }}
              />
            ))}
          </div>
          <div className="appendTop25">
            <FaqSection faq={PNR_FAQ.list} title={PNR_FAQ.title} />
          </div>
        </div>
      </main>
      <PnrFooter />
      <PnrAppDownloadSection />
    </React.Fragment>
  );
};

PnrSeo.propTypes = {
  data: PropTypes.object
};

PnrSeo.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: PNR_META_DATA.template_name,
    meta_title: PNR_META_DATA.title,
    meta_description: PNR_META_DATA.description,
    meta_keywords: PNR_META_DATA.keywords,
    analytics: getStaticPageLoadEvent('seo:rails:pnrsearch'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: PNR_META_DATA.h1Title,
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.makemytrip.com/railways/`,
        displayString: `Train Ticket Booking`
      },
      {
        displayString: `PNR Status`,
        redirectionUrl: `https://www.makemytrip.com/railways/PNR/`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: ``,
    external_js: ``,
    extra_info: ``
  };
  const pageUrl = 'https://www.makemytrip.com/railways/PNR/';
  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_PNR';
  return {
    pushToCache: true,
    cacheKey,
    pageType,
    pageUrl,
    ...finalResponse
  };
};

export default PnrSeo;
